import { controls,grouped } from "../controls";
const portal_pages = {
label: "Portal Pages",
pageLabel: "Portal Pages",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "portal_page_code",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Portal Page Name",description:'Full partial search. e.g. You can search for Sugar Cane by typing gar or can.'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "portal_page_name",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "portal_page_display",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "filter",default:true, label: "Active", name: "portal_page_active" }),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "portal_page_code",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Portal Page Name",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "portal_page_name",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "portal_page_display",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Client ID",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "clientid",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Active",default:false, name: "portal_page_active" }),
...controls.displayText({ tab: "general", label: "Code",width:"col-sm-12"}),
...controls.simpleeditor({ tab: "general",name: "code"}),
]
,history:{
perPage: 10,
reportHeader: "Portal Pages",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Portal Page Code",accessor: "portal_page_code",},
{Header: "Portal Page Name",accessor: "portal_page_name",},
{Header: "Portal Page",accessor: "portal_page_display",},
{Header: "Portal Page Active",accessor: "portal_page_active",type:'tick'},
]}};
export default portal_pages;